export default __webpack_public_path__ + "static/media/Gloves of the Huntmaster.ebd38a3d.jpg";